import FuzzyEnergyApp from './FuzzyEnergyApp';

function App() {
  return <FuzzyEnergyApp />;
}

export default App;